import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Table,
  TableCell,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import {
  Accordion,
  AccordionPanel,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import Autocomplete from "@mui/material/Autocomplete";
import Slide from "@mui/material/Slide";
import { BsThreeDots } from "react-icons/bs";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useDispatch } from "react-redux";
import {
  getAllServices,
  createService,
  updateService,
  deleteService,
} from "../../../store/action/services";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  inputContainer: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "5px",
    outline: "none",
    fontFamily: "Poppins",
    fontSize: "13px",
    padding: "5px",
    "&:focus": {
      outline: "none",
    },
  },
  ExportStyle: {
    border: "0.96px solid rgba(187, 200, 8, 1)",
    color: "rgba(187, 200, 8, 1)",
    width: "64px",
    height: "27px",
    fontFamily: "Poppins",
    fontSize: "12.76px",
    fontWeight: 400,
    lineHeight: "19.14px",
    background: "rgba(255, 255, 255, 1)",
    margin: "0 1rem",
    cursor: "pointer",
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "64px",
    height: "27px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
    cursor: "pointer",
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    position: "relative",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    top: "100%", // directly below the button
    left: 0,     // aligned with the left edge of the button
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    borderRadius: 6,
    // remove large margin offsets
    padding: "5px 0",
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    whiteSpace: "nowrap",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    padding: "5px",
    width: "100%",
    height: "36px",
    borderRadius: "4px",
    outline: "none",
    "&:focus": {
      outline: "none",
    },
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  // Additional styles for the Confirm Delete dialog
  deleteDialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "rgba(243, 246, 249, 1)",
  },
  modalButtons: {
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    lineHeight: "16.14px",
    textAlign: "left",
    width: "62px",
    height: "26px",
    borderRadius: "5.38px",
    marginRight: "10px",
  },
}));

export default function ServiceManagementUI() {
  const classes = useStyles();
  const dispatch = useDispatch();

  // State
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);

  // Filter states
  const [filterCode, setFilterCode] = useState("");
  const [filterLabel, setFilterLabel] = useState("");

  // Dialog states
  const [open, setOpen] = useState(false); // for Add/Edit/Detail
  const [isEditing, setIsEditing] = useState(false);
  const [detail, setDetail] = useState(false); // read-only detail view

  // Confirmation dialog states
  const [openConfirm, setOpenConfirm] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);

  // Current service states (for Add/Edit/Detail)
  const [serviceToEdit, setServiceToEdit] = useState(null);
  const [serviceCode, setServiceCode] = useState("");
  const [serviceLabel, setServiceLabel] = useState("");
  const [serviceId, setServiceId] = useState("");

  // Dropdown
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [currentServiceId, setCurrentServiceId] = useState(null);

  // For a small "Please wait" overlay if needed
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);

  // Table header rows
  const headRows = [
    { id: "id", align: "left", label: "Code généré", width: "20%" },
    { id: "code", align: "left", label: "Code", width: "20%" },
    { id: "label", align: "left", label: "Label", width: "40%" },
    { id: "actions", align: "center", label: "", width: "20%" },
  ];

  /* ---------------------------------- FETCH ---------------------------------- */
  const fetchServices = async () => {
    setLoading(true);
    try {
      const servicesData = await dispatch(getAllServices());
      setServices(servicesData);
      setFilteredServices(servicesData);
    } catch (error) {
      toast.error("Failed to fetch services.");
    } finally {
      setLoading(false);
    }
  };

  /* ----------------------------- FILTER HANDLERS ----------------------------- */
  const handleFilterChange = () => {
    const filtered = services.filter(
      (service) =>
        service.code.toLowerCase().includes(filterCode.toLowerCase()) &&
        service.label.toLowerCase().includes(filterLabel.toLowerCase())
    );
    setFilteredServices(filtered);
  };

  // When changing filterCode or filterLabel, refilter
  useEffect(() => {
    handleFilterChange();
  }, [filterCode, filterLabel, services]);

  /* ----------------------------- PAGINATION ----------------------------- */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /* ----------------------------- DROPDOWN ----------------------------- */
  const handleDropdownClick = (serviceId) => {
    setDropdownVisible((prev) =>
      // If user clicks on the same row, toggle. Otherwise, always show a new menu.
      currentServiceId === serviceId ? !prev : true
    );
    setCurrentServiceId(serviceId);
  };

  /* ----------------------------- ADD / EDIT / DETAIL ----------------------------- */
  const handleAddService = () => {
    // Reset states for a fresh form
    setIsEditing(false);
    setDetail(false);
    setServiceToEdit(null);
    setServiceCode("");
    setServiceLabel("");
    setServiceId("");
    setOpen(true);
  };

  const handleClickEditOpen = (service) => {
    // Populate states with existing data for edit
    setIsEditing(true);
    setDetail(false);
    setServiceToEdit(service);
    setServiceCode(service.code);
    setServiceLabel(service.label);
    setServiceId(service._id);
    setOpen(true);
  };

  const handleClickDetailOpen = (service) => {
    // Show a read-only detail view
    setDetail(true);
    setIsEditing(false);
    setServiceToEdit(service);
    setServiceCode(service.code);
    setServiceLabel(service.label);
    setServiceId(service._id);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setDropdownVisible(false);
    setOpen(false);
    setDetail(false);
    setIsEditing(false);
  };

  const handleSubmitService = async () => {
    if (!serviceCode || !serviceLabel) {
      toast.error("Please fill in both Code and Label.");
      return;
    }
    setIsRequestInProgress(true);

    try {
      const serviceData = { code: serviceCode, label: serviceLabel };
      if (isEditing && serviceToEdit) {
        await dispatch(updateService(serviceToEdit._id, serviceData));
        toast.success("Service updated successfully!");
      } else {
        await dispatch(createService(serviceData));
        toast.success("Service created successfully!");
      }
      fetchServices();
      setOpen(false);
    } catch (error) {
      toast.error("Failed to save service.");
    } finally {
      setIsRequestInProgress(false);
    }
  };

  /* ----------------------------- DELETE ----------------------------- */
  const handleClickDeleteOpen = (service) => {
    setServiceToDelete(service);
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setServiceToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (!serviceToDelete) return;
    setIsRequestInProgress(true);

    try {
      await dispatch(deleteService(serviceToDelete._id));
      toast.success("Service deleted successfully!");
      fetchServices();
    } catch (error) {
      toast.error("Failed to delete service.");
    } finally {
      setIsRequestInProgress(false);
      setOpenConfirm(false);
      setServiceToDelete(null);
    }
  };

  /* ------------------------------ INIT ------------------------------ */
  useEffect(() => {
    fetchServices();
    // eslint-disable-next-line
  }, []);

  /* ------------------------------ RENDER ------------------------------ */
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          {/* ------------------- HEADER + FILTERS (Optional) ------------------- */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "40px",
              justifyContent: "space-between",
            }}
          >
            {/* Left content (title) */}
            <div className={classes.titre}>Liste des services</div>

            {/* Right content (Add button) */}
            <button className={classes.ajouterStyle} onClick={handleAddService}>
              Ajouter
            </button>
          </div>

          {/* ------------------- TABLE ------------------- */}
          <Table size="small">
            <thead>
              <tr>
                {headRows.map((row) => (
                  <TableCell
                    height={"43px"}
                    width={row.width}
                    align={row.align}
                    className={classes.tableHeadRows}
                    key={row.id}
                  >
                    {row.label}
                  </TableCell>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading
                ? [...Array(10)].map((_, index) => (
                    <tr key={index} style={{ height: "48px" }}>
                      <TableCell align="left" className={classes.tableCellSmall}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellSmall}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellSmall}>
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell align="center" className={classes.tableCellSmall}>
                        <Skeleton animation="wave" />
                      </TableCell>
                    </tr>
                  ))
                : filteredServices.length > 0 ? (
                    filteredServices
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((service) => (
                        <tr key={service._id} style={{ height: "48px" }}>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {service._id}
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {service.code}
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {service.label}
                          </TableCell>
                          <TableCell align="right" className={classes.tableCellSmall}>
                            {/* Parent container must be position relative */}
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <button
                                className={classes.viewBtn}
                                onClick={() => handleDropdownClick(service._id)}
                              >
                                <BsThreeDots />
                              </button>
                              {dropdownVisible && currentServiceId === service._id && (
                                <div className={classes.dropdownMenu}>
                                  <div
                                    className={classes.dropdownItem}
                                    onClick={() => handleClickDetailOpen(service)}
                                  >
                                    Détail
                                  </div>
                                  <div
                                    className={classes.dropdownItem}
                                    onClick={() => handleClickEditOpen(service)}
                                  >
                                    Modifier
                                  </div>
                                  <div
                                    className={classes.dropdownItem}
                                    onClick={() => handleClickDeleteOpen(service)}
                                  >
                                    Supprimer
                                  </div>
                                </div>
                              )}
                            </div>
                          </TableCell>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <TableCell
                        align="center"
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: 400,
                          fontSize: 15,
                          lineHeight: "22.5px",
                          color: "rgba(70, 78, 95, 1)",
                          padding: "20px",
                        }}
                        colSpan={4}
                      >
                        Aucune donnée disponible
                      </TableCell>
                    </tr>
                  )}
            </tbody>
          </Table>

          {/* ------------------- PAGINATION ------------------- */}
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={filteredServices.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "18px",
              color: "rgba(32, 18, 70, 1)",
            }}
            labelRowsPerPage="Lignes par page"
          />
        </div>
      </Paper>

      {/* ------------------- ADD / EDIT / DETAIL DIALOG ------------------- */}
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        classes={{ paper: classes.dialogPaper }}
        TransitionComponent={Transition}
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
        >
          {detail
            ? "Détails du service"
            : isEditing
            ? "Modification Service"
            : "Création Service"}
        </DialogTitle>
        <DialogContent>
          <Accordion allowMultiple defaultIndex={[0]}>
            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(187, 200, 8, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Informations Générales
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                 {(isEditing || detail)  &&
                 <div
                 style={{
                   display: "flex",
                   flexDirection: "column",
                   marginBottom: "1rem",
                 }}
               >
                 <label
                   className={classes.cardText}
                   style={{ marginBottom: "0.5rem" }}
                 >
                   Code généré
                 </label>
                 <input
                   className={classes.styleInput}
                   value={serviceId}
                   disabled
                   onChange={(e) => setServiceCode(e.target.value)}
                 />
               </div>
                 }
                  

                  {/* Code */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Code
                    </label>
                    <input
                      className={classes.styleInput}
                      value={serviceCode}
                      disabled={detail}
                      onChange={(e) => setServiceCode(e.target.value)}
                    />
                  </div>

                  {/* Label */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Label
                    </label>
                    <input
                      className={classes.styleInput}
                      value={serviceLabel}
                      disabled={detail}
                      onChange={(e) => setServiceLabel(e.target.value)}
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </DialogContent>

        {/* ------------------- SINGLE ACTIONS LOGIC ------------------- */}
        {detail ? (
          // DETAIL mode: only a "Fermer" button
          <DialogActions>
            <Button
              style={{
                ...styles.cancelButton,
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
              }}
              onClick={handleCloseDialog}
            >
              Fermer
            </Button>
          </DialogActions>
        ) : (
          // CREATE / EDIT mode
          <DialogActions>
            <Button
              style={{
                ...styles.cancelButton,
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                color: "rgba(255, 54, 54, 1)",
                background: "rgba(255, 229, 229, 1)",
              }}
              onClick={handleCloseDialog}
            >
              Annuler
            </Button>
            <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
              }}
              onClick={handleSubmitService}
            >
              {isEditing ? "Modifier" : "Valider"}
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {/* ------------------- CONFIRM DELETE DIALOG ------------------- */}
      <Dialog
        open={openConfirm}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseConfirm}
      >
        <DialogTitle className={classes.deleteDialogTitle}>
          Confirmation de suppression
        </DialogTitle>
        <DialogContent>
          <p style={{ fontFamily: "Poppins", fontSize: "16px" }}>
            Êtes-vous sûr de vouloir supprimer le service
            <br />
            « {serviceToDelete?.label} » ?
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.modalButtons}
            onClick={handleCloseConfirm}
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              color: "rgba(255, 255, 255, 1)",
              background: "rgba(60, 101, 86, 1)",
            }}
          >
            Annuler
          </Button>
          <Button
            className={classes.modalButtons}
            onClick={handleConfirmDelete}
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              color: "rgba(255, 54, 54, 1)",
              background: "rgba(255, 229, 229, 1)",
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------- LOADING OVERLAY (if needed) ------------------- */}
      {isRequestInProgress && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="spinner" style={{ marginBottom: "10px" }}></div>
            <p style={{ fontFamily: "Poppins", fontSize: "16px", margin: 0 }}>
              Veuillez patienter...
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

/** Inline styles for convenience; could also add them to makeStyles. */
const styles = {
  cancelButton: {
    marginRight: "10px",
    width: "62px",
    height: "26px",
    borderRadius: "5.38px",
    cursor: "pointer",
  },
};
